import {doc} from '../docs.js';
import {lazy} from 'utils/lazy.js';
import * as THREE from "three";

doc(
    "three.mesh",
    {
        geometry: "",
        material: "",
    },
    "Create a mesh out of geometry and material",
    () => 1,
    {
        isHot: true,
        inlets: 2,
        connects: {
            object: "three.scene",
        },
        operations: {
            position: {
                parameters: ['x', 'y', 'z'],
                description: 'Sets the position of the mesh.'
            },
            rotation: {
                parameters: ['x', 'y'],
                description: 'Rotates the mesh.'
            }
        }
    }
);

export const threeMesh = (object, material) => {
    let mesh;
    let _material;
    return ([geometry]) => {
        // console.log("three.mesh material/geometry", material(), geometry);
        if (typeof geometry === "string") {
            if (geometry.startsWith("position")) {
                let tokens = geometry.split(" ");
                let [x,y,z] = tokens.slice(1).map(x => parseFloat(x));
                if (mesh) {
                    mesh.position.x = x;
                    mesh.position.y = y;
                    mesh.position.z = z;
                }
               // return;
            } else if (geometry.startsWith("rotation")) {
                let tokens = geometry.split(" ");
                let [x,y] = tokens.slice(1).map(x => parseFloat(x));
                if (mesh) {
                    mesh.rotation.x = x;
                    mesh.rotation.y = x;
                }
               // return;
            }
        
        }

        if (!geometry || !geometry.attributes) {
            if (!mesh) {
                return;
            }
        } 

        if (!mesh || (lazy(material) && _material !== lazy(material))) {
            _material = lazy(material) || new THREE.MeshBasicMaterial( { color: 0x42f581, wireframe:true } );
            _material.side = THREE.DoubleSide;
            _material.needsUpdate = true;
            if (mesh) {
                mesh.material = _material;
            } else {
                mesh = new THREE.Mesh( geometry, _material );
            }
        } 

        /*
        if (mesh.geometry !== geometry) {
            mesh.geometry = geometry;
        }
        */
        return [mesh];
    };
};

doc(
    "three.cube",
    {
        x: "",
        y: "",
        z: ""
    },
    "Create a cube",
    () => 1,
    {
        tags: "Graphics",
        isHot: true,
        inlets: 3
    }
);

export const threeCube = (object, y, z) => {
    const geometry = new THREE.BoxBufferGeometry(100,100,100);
    var mat1 = new THREE.MeshNormalMaterial();
    mat1.side = THREE.DoubleSide;
    const cube = new THREE.Mesh( geometry, mat1 );

    return ([x]) => {
        cube.position.x = x === undefined ? 2 : x;
        cube.position.y = y() === undefined ? 2 : y();
        cube.position.z = z() === undefined ? 2 : z();
        return [cube];
    };
}

doc(
    "three.gridHelper",
    {
    },
    "Grid helper",
    () => 1,
    {
        tags: "Graphics",
    }
);
export const gridHelper = () => {
    let helper = new THREE.GridHelper(10, 10);
    return () => {
        return [helper];
    };
};

doc(
    "three.points",
    {
        "points": "",
        "size": "",
        "material": "",
        "isStatic": ""
    },
    "Creates an object of poinntss to be added to a scene",
    undefined,
    {
        tags: "Graphics",
        isHot: true,
        inlets: 4
    });

const points = (object, size, material, isStatic) => {
    let geometry; 
    let _material;
    let hasColor = false;
    let mesh; 
    let lastSize = undefined;
    return ([points]) => {
        if (ArrayBuffer.isView(points)) {
            if (!geometry || (material() && material() !== mesh.material)) {
                if (!geometry) {
                    geometry = new THREE.BufferGeometry();
                }
                let _points = points ;
                if (!isStatic()) {
                    _points = new Float32Array(points.length*2);
                    _points.set(points, 0);
                }
                geometry.setAttribute('position', new THREE.Float32BufferAttribute(_points, 3 ));
                _material = material() || new THREE.PointsMaterial({ color: 0x99ccff, size: size() || 1 });
                // _material.side = THREE.DoubleSide;

                if (mesh) {
                    mesh.material = _material;
                    mesh.material.needsUpdate = true;
                } else {
                    mesh = new THREE.Points(
                        geometry,
                        _material);
                }
                geometry.setDrawRange(0, points.length / 3);
            } else {
                if (!isStatic() && geometry.attributes.position.array.length < points.length) {
                    geometry.setAttribute('position', new THREE.Float32BufferAttribute(points, 3 ));
                    geometry.attributes.position.needsUpdate = true;
                } else if (!isStatic()) {
                    geometry.attributes.position.array.set(points, 0);
                    geometry.attributes.position.needsUpdate = true;
                }
                geometry.setDrawRange(0, points.length / 3);

                if (lastSize !== (size() || 1)) {
                    mesh.material.size = size() || 1;
                    mesh.material.needsUpdate = true;
                    lastSize = mesh.material.size;
                }
            }
        }
        return [mesh];
    };
};


doc(
    "three.attribute",
    {
        mesh: "",
        name: "",
        itemSize: "",
        array: ""
    },
    "Receives a Mesh object and sets an attribute with the arguments",
    undefined,
    {
        tags: "Graphics",
        inlets: 4
    });

const attribute = (object, name, itemSize, array) => {
    let isSet = false;
    return ([mesh]) => {
        if (!mesh || !mesh.geometry) {
            return;
        }

        if (!name() || !itemSize() || !array()) {
            // need every argument to exist before executing
            return;
        }

        let {geometry} = mesh; 
        if (!isSet || geometry.attributes[name()].array.length !== array().length) {
            geometry.setAttribute(name(), new THREE.BufferAttribute(array(), itemSize()));
        } else {
            geometry.attributes[name()].array.set(array(), 0);
            geometry.attributes[name()].needsUpdate = true;
        }

        isSet = true;

        return [mesh];
    };
};

export const mesh = {
    "three.attribute": attribute,
    "three.points": points,
    "three.gridHelper": gridHelper,
    "three.cube": threeCube,
    "three.mesh": threeMesh
};
